import React from "react";

const EmptyData = ({ text }) => {
  return <div className="empty-text text-center my-5">{text}</div>;
};

export default EmptyData;
